package core.firebase

import kotlin.js.Promise

/**
 * Minimal wrapper around Firebase Firestore
 * Provides access to the Firestore database instance
 */
object FirestoreClient {
    val db: Firestore
        get() = FirebaseService.db
}
